
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"16","viewBox":"0 0 10 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.55392 15.7443L9.07512 15.2202C9.23789 15.0552 9.32756 14.8358 9.32756 14.6012C9.32756 14.3668 9.23789 14.1471 9.07512 13.9822L3.17039 8.00358L9.08167 2.0181C9.24444 1.85341 9.33398 1.6337 9.33398 1.3993C9.33398 1.16489 9.24444 0.945048 9.08167 0.780234L8.56368 0.256002C8.22683 -0.085334 7.67814 -0.085334 7.34129 0.256002L0.27789 7.38243C0.115247 7.54712 0.00065136 7.76657 0.00065136 8.00306V8.00579C0.00065136 8.24033 0.115376 8.45978 0.27789 8.62446L7.32215 15.7443C7.48479 15.9092 7.70807 15.9997 7.93957 16C8.1712 16 8.3914 15.9092 8.55392 15.7443Z","fill":"#FFFFFF"}})])
          )
        }
      }
    